import { FC } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Landing from './page/landing';
import Home from './page/home';
import Download from './page/download/Download';
import PrivacyPolicy from './page/policy/PrivacyPolicy';
import AfterSalesPolicy from './page/policy/AfterSalesPolicy';
import UseAfterSalesPolicy from './page/policy/UseAfterSalesPolicy';
import UsePolicy from './page/policy/UsePolicy';

const AppRouter: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/download" element={<Download />} />
        <Route path="/privacypolicy" key={'privacypolicy'} element={<PrivacyPolicy />} />
        <Route path="/policy" key={'policy'} element={<PrivacyPolicy />} />
        <Route path="/salespolicy" element={<AfterSalesPolicy />} />
        <Route path="/usepolicy" element={<UsePolicy />} />
        <Route path="/usesalespolicy" element={<UseAfterSalesPolicy />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
